"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../../Theme/Theme");
const add_svg_1 = __importDefault(require("../../assets/icons/add.svg"));
const addNote_svg_1 = __importDefault(require("../../assets/icons/addNote.svg"));
const arrowDown_svg_1 = __importDefault(require("../../assets/icons/arrowDown.svg"));
const arrowLeft_svg_1 = __importDefault(require("../../assets/icons/arrowLeft.svg"));
const arrowRight_svg_1 = __importDefault(require("../../assets/icons/arrowRight.svg"));
const arrowUp_svg_1 = __importDefault(require("../../assets/icons/arrowUp.svg"));
const attention_svg_1 = __importDefault(require("../../assets/icons/attention.svg"));
const attentionOrange_svg_1 = __importDefault(require("../../assets/icons/attentionOrange.svg"));
const attentionRed_svg_1 = __importDefault(require("../../assets/icons/attentionRed.svg"));
const attentionTriangle_svg_1 = __importDefault(require("../../assets/icons/attentionTriangle.svg"));
const bulkDef_svg_1 = __importDefault(require("../../assets/icons/bulkDef.svg"));
const check_svg_1 = __importDefault(require("../../assets/icons/check.svg"));
const checkGray_svg_1 = __importDefault(require("../../assets/icons/checkGray.svg"));
const checkGreen_svg_1 = __importDefault(require("../../assets/icons/checkGreen.svg"));
const checkboxEmpty_svg_1 = __importDefault(require("../../assets/icons/checkboxEmpty.svg"));
const checkboxFilled_svg_1 = __importDefault(require("../../assets/icons/checkboxFilled.svg"));
const chevronDown_svg_1 = __importDefault(require("../../assets/icons/chevronDown.svg"));
const chevronLeft_svg_1 = __importDefault(require("../../assets/icons/chevronLeft.svg"));
const chevronRight_svg_1 = __importDefault(require("../../assets/icons/chevronRight.svg"));
const chevronUp_svg_1 = __importDefault(require("../../assets/icons/chevronUp.svg"));
const chrome_svg_1 = __importDefault(require("../../assets/icons/chrome.svg"));
const clipboard_svg_1 = __importDefault(require("../../assets/icons/clipboard.svg"));
const close_svg_1 = __importDefault(require("../../assets/icons/close.svg"));
const closeGrey_svg_1 = __importDefault(require("../../assets/icons/closeGrey.svg"));
const csv_svg_1 = __importDefault(require("../../assets/icons/csv.svg"));
const delete_svg_1 = __importDefault(require("../../assets/icons/delete.svg"));
const denied_svg_1 = __importDefault(require("../../assets/icons/denied.svg"));
const document_svg_1 = __importDefault(require("../../assets/icons/document.svg"));
const documentAdd_svg_1 = __importDefault(require("../../assets/icons/documentAdd.svg"));
const documentComplete_svg_1 = __importDefault(require("../../assets/icons/documentComplete.svg"));
const documentFlagged_svg_1 = __importDefault(require("../../assets/icons/documentFlagged.svg"));
const documentInclude_svg_1 = __importDefault(require("../../assets/icons/documentInclude.svg"));
const documentPending_svg_1 = __importDefault(require("../../assets/icons/documentPending.svg"));
const edge_svg_1 = __importDefault(require("../../assets/icons/edge.svg"));
const eyeHide_svg_1 = __importDefault(require("../../assets/icons/eyeHide.svg"));
const eyeShow_svg_1 = __importDefault(require("../../assets/icons/eyeShow.svg"));
const faq_svg_1 = __importDefault(require("../../assets/icons/faq.svg"));
const featuredStationNote_svg_1 = __importDefault(require("../../assets/icons/featuredStationNote.svg"));
const filter_svg_1 = __importDefault(require("../../assets/icons/filter.svg"));
const firefox_svg_1 = __importDefault(require("../../assets/icons/firefox.svg"));
const getDirections_svg_1 = __importDefault(require("../../assets/icons/getDirections.svg"));
const giveFeedback_svg_1 = __importDefault(require("../../assets/icons/giveFeedback.svg"));
const history_svg_1 = __importDefault(require("../../assets/icons/history.svg"));
const hold_svg_1 = __importDefault(require("../../assets/icons/hold.svg"));
const laundry_svg_1 = __importDefault(require("../../assets/icons/laundry.svg"));
const linkGray_svg_1 = __importDefault(require("../../assets/icons/linkGray.svg"));
const logout_svg_1 = __importDefault(require("../../assets/icons/logout.svg"));
const lounge_svg_1 = __importDefault(require("../../assets/icons/lounge.svg"));
const message_svg_1 = __importDefault(require("../../assets/icons/message.svg"));
const multiSelect_svg_1 = __importDefault(require("../../assets/icons/multiSelect.svg"));
const pdf_svg_1 = __importDefault(require("../../assets/icons/pdf.svg"));
const pdfBroken_svg_1 = __importDefault(require("../../assets/icons/pdfBroken.svg"));
const phone_svg_1 = __importDefault(require("../../assets/icons/phone.svg"));
const plus_svg_1 = __importDefault(require("../../assets/icons/plus.svg"));
const plusBlue_svg_1 = __importDefault(require("../../assets/icons/plusBlue.svg"));
const plusWhite_svg_1 = __importDefault(require("../../assets/icons/plusWhite.svg"));
const redX_svg_1 = __importDefault(require("../../assets/icons/redX.svg"));
const refresh_svg_1 = __importDefault(require("../../assets/icons/refresh.svg"));
const refreshBlue_svg_1 = __importDefault(require("../../assets/icons/refreshBlue.svg"));
const refreshGrey_svg_1 = __importDefault(require("../../assets/icons/refreshGrey.svg"));
const restaurant_svg_1 = __importDefault(require("../../assets/icons/restaurant.svg"));
const rtsDocument_svg_1 = __importDefault(require("../../assets/icons/rtsDocument.svg"));
const safari_svg_1 = __importDefault(require("../../assets/icons/safari.svg"));
const saved_svg_1 = __importDefault(require("../../assets/icons/saved.svg"));
const search_svg_1 = __importDefault(require("../../assets/icons/search.svg"));
const searchBlack_svg_1 = __importDefault(require("../../assets/icons/searchBlack.svg"));
const searchWhite_svg_1 = __importDefault(require("../../assets/icons/searchWhite.svg"));
const shop_svg_1 = __importDefault(require("../../assets/icons/shop.svg"));
const sort_svg_1 = __importDefault(require("../../assets/icons/sort.svg"));
const stationNote_svg_1 = __importDefault(require("../../assets/icons/stationNote.svg"));
const status_svg_1 = __importDefault(require("../../assets/icons/status.svg"));
const thumbsDown_svg_1 = __importDefault(require("../../assets/icons/thumbsDown.svg"));
const thumbsUp_svg_1 = __importDefault(require("../../assets/icons/thumbsUp.svg"));
const triangleDown_svg_1 = __importDefault(require("../../assets/icons/triangleDown.svg"));
const truckCare_svg_1 = __importDefault(require("../../assets/icons/truckCare.svg"));
const truckWash_svg_1 = __importDefault(require("../../assets/icons/truckWash.svg"));
const upload_svg_1 = __importDefault(require("../../assets/icons/upload.svg"));
const user_svg_1 = __importDefault(require("../../assets/icons/user.svg"));
const wifi_svg_1 = __importDefault(require("../../assets/icons/wifi.svg"));
const playWhite_svg_1 = __importDefault(require("../../assets/icons/playWhite.svg"));
const documentBlue_svg_1 = __importDefault(require("../../assets/icons/documentBlue.svg"));
const checkCircleGreen_svg_1 = __importDefault(require("../../assets/icons/checkCircleGreen.svg"));
const download_svg_1 = __importDefault(require("../../assets/icons/download.svg"));
const print_svg_1 = __importDefault(require("../../assets/icons/print.svg"));
const fundingDetails_svg_1 = __importDefault(require("../../assets/icons/fundingDetails.svg"));
const resubmit_svg_1 = __importDefault(require("../../assets/icons/resubmit.svg"));
const pdfBlue_svg_1 = __importDefault(require("../../assets/icons/pdfBlue.svg"));
const filterBlue_svg_1 = __importDefault(require("../../assets/icons/filterBlue.svg"));
const pencil_svg_1 = __importDefault(require("../../assets/icons/pencil.svg"));
const Icons = {
    add: add_svg_1.default,
    addNote: addNote_svg_1.default,
    arrowDown: arrowDown_svg_1.default,
    arrowLeft: arrowLeft_svg_1.default,
    arrowRight: arrowRight_svg_1.default,
    arrowUp: arrowUp_svg_1.default,
    attention: attention_svg_1.default,
    attentionOrange: attentionOrange_svg_1.default,
    attentionRed: attentionRed_svg_1.default,
    attentionTriangle: attentionTriangle_svg_1.default,
    bulkDef: bulkDef_svg_1.default,
    check: check_svg_1.default,
    checkGray: checkGray_svg_1.default,
    checkGreen: checkGreen_svg_1.default,
    checkboxEmpty: checkboxEmpty_svg_1.default,
    checkboxFilled: checkboxFilled_svg_1.default,
    checkCircleGreen: checkCircleGreen_svg_1.default,
    chevronDown: chevronDown_svg_1.default,
    chevronLeft: chevronLeft_svg_1.default,
    chevronRight: chevronRight_svg_1.default,
    chevronUp: chevronUp_svg_1.default,
    chrome: chrome_svg_1.default,
    clipboard: clipboard_svg_1.default,
    close: close_svg_1.default,
    closeGrey: closeGrey_svg_1.default,
    csv: csv_svg_1.default,
    deleteIcon: delete_svg_1.default,
    denied: denied_svg_1.default,
    document: document_svg_1.default,
    documentAdd: documentAdd_svg_1.default,
    documentBlue: documentBlue_svg_1.default,
    documentComplete: documentComplete_svg_1.default,
    documentFlagged: documentFlagged_svg_1.default,
    documentInclude: documentInclude_svg_1.default,
    documentPending: documentPending_svg_1.default,
    download: download_svg_1.default,
    edge: edge_svg_1.default,
    eyeHide: eyeHide_svg_1.default,
    eyeShow: eyeShow_svg_1.default,
    faq: faq_svg_1.default,
    featuredStationNote: featuredStationNote_svg_1.default,
    filter: filter_svg_1.default,
    filterBlue: filterBlue_svg_1.default,
    firefox: firefox_svg_1.default,
    fundingDetails: fundingDetails_svg_1.default,
    getDirections: getDirections_svg_1.default,
    giveFeedback: giveFeedback_svg_1.default,
    history: history_svg_1.default,
    hold: hold_svg_1.default,
    laundry: laundry_svg_1.default,
    linkGray: linkGray_svg_1.default,
    logout: logout_svg_1.default,
    lounge: lounge_svg_1.default,
    message: message_svg_1.default,
    multiSelect: multiSelect_svg_1.default,
    pdf: pdf_svg_1.default,
    pdfBlue: pdfBlue_svg_1.default,
    pdfBroken: pdfBroken_svg_1.default,
    pencil: pencil_svg_1.default,
    phone: phone_svg_1.default,
    playWhite: playWhite_svg_1.default,
    plus: plus_svg_1.default,
    plusBlue: plusBlue_svg_1.default,
    plusWhite: plusWhite_svg_1.default,
    print: print_svg_1.default,
    redX: redX_svg_1.default,
    refresh: refresh_svg_1.default,
    refreshBlue: refreshBlue_svg_1.default,
    refreshGrey: refreshGrey_svg_1.default,
    restaurant: restaurant_svg_1.default,
    resubmit: resubmit_svg_1.default,
    rtsDocument: rtsDocument_svg_1.default,
    safari: safari_svg_1.default,
    saved: saved_svg_1.default,
    search: search_svg_1.default,
    searchBlack: searchBlack_svg_1.default,
    searchWhite: searchWhite_svg_1.default,
    shop: shop_svg_1.default,
    sort: sort_svg_1.default,
    stationNote: stationNote_svg_1.default,
    status: status_svg_1.default,
    thumbsDown: thumbsDown_svg_1.default,
    thumbsUp: thumbsUp_svg_1.default,
    triangleDown: triangleDown_svg_1.default,
    truckCare: truckCare_svg_1.default,
    truckWash: truckWash_svg_1.default,
    upload: upload_svg_1.default,
    user: user_svg_1.default,
    wifi: wifi_svg_1.default,
};
const IconImg = Theme_1.styled.div `
  mask: url(${(props) => Icons[props.icon]}) no-repeat center;
  mask-size: contain;
  ${(props) => props.color
    ? `background-color: ${props.theme[props.color]};`
    : `background-image: url(${Icons[props.icon]});`}
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  height: ${(props) => (props.size ? `${props.size}px` : '25px')};
  width: ${(props) => (props.size ? `${props.size}px` : '25px')};
  cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
`;
exports.Icon = (props) => {
    return react_1.default.createElement(IconImg, Object.assign({}, props));
};
exports.default = exports.Icon;
//# sourceMappingURL=Icon.js.map